module.exports = __webpack_public_path__ + "static/media/md-git-network.7e6b6071.svg";